import { useEffect, useRef, useState } from "react";

import { ArrowLeftTabIcon } from "../icons/ArrowLeftTabIcon";
import { ArrowRightTabIcon } from "../icons/ArrowRightTabIcon";

import "./NavigationTabs.scss";

export const NavigationTabs = ({changePage, head}: {changePage: (value: any) => void, head: any}) => {
    const divRef = useRef<any>(null);

    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [tabs, setTabs] = useState<any[]>([]);

    useEffect(() => {
        const tabsResult: any[] = [
            {
                title: "Заявки",
                type: "processes"
            },
            {
                title: "Контакты",
                type: "contacts"
            }
        ];
        const active = tabsResult.findIndex(x => x.type === head);
        setActiveTab(active !== -1 ? active : 0);

        setTabs(tabsResult);
        setShowRight(tabsResult.length > 2);
    }, []);
    
    const scrollRight = () => {
        setShowLeft(true);
        setShowRight(divRef.current.scrollLeft + divRef.current.clientWidth + 200 < divRef.current.scrollWidth);
        divRef.current.scroll({
            left: divRef.current.scrollLeft + 200,
            behavior: 'smooth'
        });
    }

    const scrollLeft = () => {
        setShowLeft(divRef.current.scrollLeft > 200);
        setShowRight(divRef.current.scrollLeft + divRef.current.clientWidth - 200 < divRef.current.scrollWidth);
        divRef.current.scroll({
            left: divRef.current.scrollLeft - 200,
            behavior: 'smooth'
        });
    }

    const changeTab = (tab: string, key: number) => {
        setActiveTab(key);
        changePage(tab);
    }

    return tabs.length > 1 ? <div className="tm-communication-tabs-container" ref={divRef}>
        {showLeft &&
            <div onClick={scrollLeft} className={"tm-communication-tabs-left-btn"}><ArrowLeftTabIcon/>
            </div>}
        {tabs.map((item: any, key: any) => <div key={key}
                                      className={`tm-communication-tab ${activeTab === key ? 'tm-communication-tab_active' : ''}`}
                                      onClick={() => changeTab(item.type, key)}>{item.title}
        </div>)}
        {showRight && <div onClick={scrollRight} className={"tm-communication-tabs-right-btn"}><ArrowRightTabIcon/></div>}
    </div> : <></>;
}